
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator'

import { City } from '@/model/City'
import { Permissions } from '@/model/Permissions'
import { IAccessControlService } from '@/services/acl/IAccessControlService'
import { getAllRegularRepresentations, RegularRepresentation, regularRepresentations } from '@/model/Representation'

@Component({
  components: {},
})
export default class RepresentationSelector extends Vue {
  @Prop() private city?: City
  @Prop() private showStationRepresentation?: boolean

  @VModel() selectedRepresentation!: RegularRepresentation

  representations: RegularRepresentation[] = []
  private accessControlService!: IAccessControlService

  created(): void {
    this.representations = getAllRegularRepresentations()
    this.accessControlService = this.$services.get<IAccessControlService>('acl')
  }

  @Watch('city')
  onCityChanged(): void {
    if (this.city?.getCatchments().isEmpty && this.selectedRepresentation.requiresCatchments) {
      this.selectedRepresentation = regularRepresentations.rainfall
    }
  }

  get isCatchmentsEmpty(): boolean {
    return this.city?.getCatchments()?.isEmpty ?? true
  }

  hasAccess(representation: RegularRepresentation): boolean {
    switch (representation.type) {
      case 'rainfall':
      case 'flood risk':
        return true
      case 'return period':
        return this.accessControlService.hasPermission(Permissions.FULL_ACCESS)
      case 'flood depth':
        return this.accessControlService.hasFloodAccess
    }
  }
}
